export default defineNuxtPlugin(async (nuxtApp) => {
  const { store, key } = await import("~/store");
  nuxtApp.vueApp.use(store, key);
});
